import { RootState } from "../../../../../redux/store";
import { createSelector } from "reselect";
import { WorkOrderAssetsTabState } from "../types/work-order-assets-tab-state/work-order-assets-tab-state.interface";
import Store from "../../../../../redux/store";
import * as actions from "./work-order-assets-tab.actions";

export const getWorkOrderAssetsTabState = (state: RootState) => state.workOrderAssetsTabState;

export const getAssets = createSelector(
  getWorkOrderAssetsTabState,
  (state: WorkOrderAssetsTabState) => state.assets
);

export const isLoading = createSelector(
  getWorkOrderAssetsTabState,
  (state: WorkOrderAssetsTabState) => state.isLoading
);

export function fetchAssets(workOrderId: number) {
  Store.dispatch(actions.fetchAssets(workOrderId));
}

export function uploadFiles(files: File[]) {
  Store.dispatch(actions.uploadAssets(files));
}

export function deleteAsset(assetId: number) {
  Store.dispatch(actions.deleteAsset(assetId));
}
